var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('button-view',{ref:"mybutton",attrs:{"value":_vm.value,"viewStyles":_vm.viewStyles,"state":_vm.state,"has-actions":_vm.hasActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }